import { render } from "./Aug2Vegas.vue?vue&type=template&id=c0b6ec52"
import script from "./Aug2Vegas.vue?vue&type=script&lang=js"
export * from "./Aug2Vegas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__